'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dList$002dRestricted$002dDomains$0024 from "./presto.-List-Restricted-Domains$.js";
import * as $j_presto$002e$002dPresto$002dRouter$0024$0024anon$002481 from "./presto.-Presto-Router$$anon$81.js";
var $p;
/** @constructor */
function $c_Lpresto_PrestoRouter$$anon$80() {
  this.boF = null;
  this.box = null;
  this.boy = false;
  this.boG = null;
  this.boH = false;
  this.boK = null;
  this.boD = null;
  this.boE = false;
  this.boz = null;
  this.boA = false;
  this.boB = null;
  this.boC = false;
  this.boI = false;
  this.boJ = false;
  this.boF = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.boK = "ListRestrictedDomains";
}
export { $c_Lpresto_PrestoRouter$$anon$80 as $c_Lpresto_PrestoRouter$$anon$80 };
$p = $c_Lpresto_PrestoRouter$$anon$80.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_PrestoRouter$$anon$80;
/** @constructor */
function $h_Lpresto_PrestoRouter$$anon$80() {
}
export { $h_Lpresto_PrestoRouter$$anon$80 as $h_Lpresto_PrestoRouter$$anon$80 };
$h_Lpresto_PrestoRouter$$anon$80.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.K = (function() {
  return this.boF;
});
$p.M = (function() {
  if ((!this.boy)) {
    this.box = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.boy = true;
  }
  return this.box;
});
$p.O = (function() {
  if ((!this.boH)) {
    this.boG = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.boH = true;
  }
  return this.boG;
});
$p.D = (function() {
  return this.boK;
});
$p.t = (function() {
  if ((!this.boE)) {
    this.boD = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.boE = true;
  }
  return this.boD;
});
$p.N = (function() {
  if ((!this.boA)) {
    this.boz = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.boA = true;
  }
  return this.boz;
});
$p.Q = (function() {
  if ((!this.boC)) {
    this.boB = new $j_presto$002e$002dPresto$002dRouter$0024$0024anon$002481.$c_Lpresto_PrestoRouter$$anon$81();
    this.boC = true;
  }
  return this.boB;
});
$p.v = (function() {
  if ((!this.boJ)) {
    this.boI = false;
    this.boJ = true;
  }
  return this.boI;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee535) => ((p) => \u03b4scrutinee535))($j_presto$002e$002dList$002dRestricted$002dDomains$0024.$m_Lpresto_ListRestrictedDomains$())));
});
var $d_Lpresto_PrestoRouter$$anon$80 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_PrestoRouter$$anon$80, "presto.PrestoRouter$$anon$80", ({
  OX: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_PrestoRouter$$anon$80 as $d_Lpresto_PrestoRouter$$anon$80 };
//# sourceMappingURL=presto.-Presto-Router$$anon$80.js.map
